import { LocalizationService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { leptonXTranslateOverrides } from './leptonx-translate-overrides';

@Injectable()
export class LeptonXTranslateService {
  constructor(private readonly localizationService: LocalizationService) {}

  get(key: string, defaultValue?: string): string {
    const localizationKey = this.getLocalizationKey(key);

    if (!localizationKey) {
      return defaultValue || key;
    }

    if (!this.isLocalizationKey(localizationKey)) {
      return localizationKey;
    }

    return this.localizationService.instant({
      key: localizationKey,
      defaultValue,
    });
  }

  get$(key: string, defaultValue?: string): Observable<string> {
    const localizationKey = this.getLocalizationKey(key);

    if (!localizationKey) {
      return of(defaultValue || key);
    }

    if (!this.isLocalizationKey(localizationKey)) {
      return of(localizationKey);
    }

    return this.localizationService.get({
      key: localizationKey,
      defaultValue,
    });
  }

  private getLocalizationKey(key: string): string | undefined {
    return leptonXTranslateOverrides[key] ?? (key.includes('::') ? key : undefined);
  }

  private isLocalizationKey(value: string): boolean {
    return value.includes('::');
  }
}
